// Adattatore verso la configurazione unica degli ambienti (vedi ./env.js).
// Punta al micro-servizio auth/menu (bkMenu). Per cambiare ambiente modificare env.js.
import env from './env';

const impostazioni = {
    api_url: env.menu,
}

export default impostazioni;
